/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Player_Guide_TitleInputs */



/**
* | output |
* | --- |
* | "Player Guide" |
*
* @param {Help_Player_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_player_guide_title = /** @type {((inputs?: Help_Player_Guide_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Player_Guide_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide du joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía del jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Guia do Jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida del Giocatore")
	return /** @type {LocalizedString} */ ("Player Guide")
});